import {plainToClass} from "class-transformer";
import {WordEntry} from "./WordEntry";

export enum Syllabary {
    katakana = "Katakana",
    hiragana = "Hiragana"
}

export class WordFetcher {
    public wordList: WordEntry[];
    public readonly katakana = ['ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ー', 'ッ', 'ャ', 'ュ', 'ョ', 'ン'];
    public readonly hiragana = ['あ', 'い', 'う', 'え', 'お', 'か', 'き', 'く', 'け', 'こ', 'さ', 'し', 'す', 'せ', 'そ', 'た', 'ち', 'つ', 'て', 'と', 'な', 'に', 'ぬ', 'ね', 'の', 'は', 'ひ', 'ふ', 'へ', 'ほ', 'ま', 'み', 'む', 'め', 'も', 'や', 'ゆ', 'よ', 'ら', 'り', 'る', 'れ', 'ろ', 'わ', 'ん', 'っ', 'が', 'ぎ', 'ぐ', 'げ', 'ご', 'ざ', 'じ', 'ず', 'ぜ', 'ぞ', 'だ', 'ぢ', 'づ', 'で', 'ど', 'ば', 'び', 'ぶ', 'べ', 'ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ',];
    public static readonly katakanaDakutenMapping: Map<string, string> = new Map([  ['ガ','カ'],['ギ','キ'],['グ','ク'],['ゲ','ケ'],['ゴ','コ'],
                                                                                　   ['ザ','サ'],['ジ','シ'],['ズ','ス'],['ゼ','セ'],['ゾ','ソ'],
                                                                                    ['ダ','タ'],['ヂ','チ'],['ヅ','ツ'],['デ','テ'],['ド','ト'],
                                                                                    ['バ','ハ'],['ビ','ヒ'],['ブ','フ'],['ベ','ヘ'],['ボ','ホ']]);
    public static readonly katakanaHandakutenMapping: Map<string, string> = new Map([['パ','ハ'],['ピ','ヒ'],['プ','フ'],['ペ','ヘ'],['ポ','ホ']]);
    public static katakanaDiacriticsMapping(): Map<string, string> {
        return new Map(Array.from(this.katakanaDakutenMapping).concat(Array.from(this.katakanaHandakutenMapping)));
    }
    public static readonly hiraganaDakutenMapping: Map<string, string> = new Map([['が','か'],['ぎ','き'],['ぐ','く'],['げ','け'],['ご','こ'],
                                                                                  ['ざ','さ'],['じ','し'],['ず','す'],['ぜ','せ'],['ぞ','そ'],
                                                                                  ['だ','た'],['ぢ','ち'],['づ','つ'],['で','て'],['ど','と'],
                                                                                  ['ば','は'],['び','ひ'],['ぶ','ふ'],['べ','へ'],['ぼ','ほ'],
                                                                                ]);
    public static readonly hiraganaHandakutenMapping: Map<string, string> = new Map([['ぱ','は'],['ぴ','ひ'],['ぷ','ふ'],['ぺ','へ'],['ぽ','ほ']]);
    public static hiraganaDiacriticsMapping(): Map<string, string> {
        return new Map(Array.from(this.hiraganaDakutenMapping).concat(Array.from(this.hiraganaHandakutenMapping)));
    }
    private readonly katakanaSpecial = ['ッ', 'ー', 'ャ', 'ュ', 'ョ'];
    private readonly hiraganaSpecial = ['っ', 'ゃ', 'ゅ', 'ょ'];

    private currentDiacriticMapping: Map<string, string>;
    private currentCharacters: string[];
    private syllabary: Syllabary;

    constructor(wordList: object[], syllabary: Syllabary) {
        this.wordList = wordList.map(word => plainToClass(WordEntry, word as object));
        let result = this.getCharacterInfo(syllabary);
        this.currentDiacriticMapping = result.diacriticsMapping;
        this.currentCharacters = result.characters;
        this.syllabary = syllabary;
    }

    public characterStatistics(characters: string): number {
        const regexp = new RegExp('^[' + characters + ']+$');

        let matches = this.wordList.filter((value) => {
            // if(regexp.test(value.reading)) {
            //     console.log("value: '" + value.reading + "' regex: '" + regexp + "' = " + value.reading.match(regexp));
            // }
            return regexp.test(value.reading)
        }).length;
        console.log('matches: ' + matches);
        return matches
    }

    public mostPopular(length: number, limit: number = 100): [string, number] {
        const G = require('generatorics');
        let max = 0;
        let maxCombinations = [];
        const candidates = this.currentCharacters.filter( char =>  { return !this.currentDiacriticMapping.has(char) });
        const combination = G.clone.combination(candidates, length);
        let comb;
        while ((comb = combination.next()).value !== undefined) {
            const join = comb.value.join('');
            const count = this.characterStatistics(join);
            if (count > max) {
                max = count;
                maxCombinations = [join];
                console.log("new max: " + max + " from: " + maxCombinations.join(', '));
            } else if (count >= max) {
                maxCombinations.push(join);
            }
            if (max >= limit) {
                break;
            }
        }

        return [maxCombinations[0], max];
    }

    public bestNext(known: string, availableCharacters: string[]): {nextChar: string, nextScore: number} {
        let max = 0;
        let maxCombinations: string[] = [];
        const candidates = availableCharacters.filter( char =>  {
            return !this.currentDiacriticMapping.has(char) || known.includes(this.currentDiacriticMapping.get(char) || '')
        });
        for (const character of candidates) {
            const join = known + character;
            const count = this.characterStatistics(join);
            if (count > max) {
                max = count;
                maxCombinations = [character];
            } else if (count >= max) {
                maxCombinations.push(character);
            }
        }
        return {nextChar: maxCombinations[0], nextScore: max};
    }

    public nextWords(currentCharacters: string, newCharacter: string, targetCount: number) {
        const newWords: WordEntry[] = [];
        const knownCharRegexp = '^[' + currentCharacters + newCharacter + ']+$';
        const newCharRegexp = newCharacter;
        this.wordList.some((word: WordEntry) => {
            if (word.reading.match(knownCharRegexp) !== null && word.reading.match(newCharRegexp) !== null) {
                newWords.push(word);
            }
            return newWords.length === targetCount;
        });
        return newWords;
    }

    public plotPath(start: string): [string, number][] {
        const path: Array<[string, number]> = [[start, this.characterStatistics(start)]];
        let learned = start;
        let readSpecial = false;
        let left = this.currentCharacters.filter((value) => {
            return !learned.includes(value) && !(this.katakanaSpecial.concat(this.hiraganaSpecial)).join('').includes(value);
        });
        let wordPath: Map<string, WordEntry[]> = new Map();
        let initialWords = this.nextWords(start, '', 30);
        wordPath.set('', initialWords);
        while (left.length !== 0) {
            console.log('left: ' + left);
            let {nextChar, nextScore} = this.bestNext(learned, left);
            let targetCount = (this.katakanaSpecial.join('').includes(nextChar)
                || this.hiraganaSpecial.join('').includes(nextChar)) ? 100 : 30;
            wordPath.set(nextChar, this.nextWords(learned, nextChar, targetCount));
            learned = learned + nextChar;
            left = left.filter((value) => {
                return value !== nextChar
            });
            path.push([nextChar, nextScore]);
            if(left.length == 0 && !readSpecial) {
                if(this.syllabary == Syllabary.hiragana) {
                    left = this.hiraganaSpecial;
                } else {
                    left = this.katakanaSpecial;
                }
                readSpecial = true;
            }
        }
        console.log("wordPath: " + JSON.stringify(Array.from(wordPath.entries())));
        return path;
    }

    public wordsMatching(restrictTo: string[], mustHave: string): WordEntry[] {
        return this.wordList.filter((value) => {
            const restrictToRegex = '^[' + restrictTo.join('') + ']+$';
            const mustHaveRegex = mustHave;
            return value.reading.match(restrictToRegex) !== null && value.reading.match(mustHaveRegex);
        });
    }

    private getCharacterInfo(syllabary: Syllabary): { characters: string[], diacriticsMapping: Map<string, string>} {
        if (syllabary == Syllabary.katakana) {
            return {
                diacriticsMapping: WordFetcher.katakanaDiacriticsMapping(),
                characters: this.katakana,
            }
        } else if (syllabary == Syllabary.hiragana) {
            return {
                diacriticsMapping: WordFetcher.hiraganaDiacriticsMapping(),
                characters: this.hiragana,
            }
        } else {
            throw new Error("Unexpected syllabary: " + syllabary);
        }
    }
}

export default {WordFetcher}


// WEBPACK FOOTER //
// ./src/WordFetcher.ts